<div class="inner-page-wrapper pt-16 lg:pt-24">
    <h1 class="text-24 leading-28 md:text-center md:text-50 md:leading-58">
        {{ headline() }}
    </h1>
    <h2 class="text-16 leading-27 md:text-center md:text-22 md:leading-[22px]">
        {{ subheadline() }}
    </h2>
</div>
